import { useSelector, useDispatch } from 'react-redux';
import { setOpenModal, setCloseModal } from 'store/actions/app';
import { TYPE_MODALS_DOWNLOAD } from 'config/constants';

const useModal = () => {
  const dispatch = useDispatch();

  const handleOpenModal = e => dispatch(setOpenModal(e));
  const handleCloseModal = () => dispatch(setCloseModal());
  const { showModal, showModalType } = useSelector(state => state.appReducer);
  return { TYPE_MODALS_DOWNLOAD, showModal, showModalType, handleOpenModal, handleCloseModal }
}

export default useModal;
